module.exports = __webpack_public_path__ + "static/img/live-to-learn__small.b1f1d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/aside/live-to-learn__small.jpg
// module id = Yb5O
// module chunks = 1